import React, { Fragment } from 'react'
import { Button} from './styles'
import './prueba.css'

export const ButtonLink = ({ text, url }) => {
    return (
        <Fragment>
            <svg width="0" height="0" style={{position: 'absolute'}}> 
                <filter id="filter">
                    <feTurbulence type="fractalNoise" baseFrequency=".01" numOctaves="6" />
                    <feDisplacementMap in="SourceGraphic" scale="100" />
                </filter>
            </svg>

            <Button>
		        <span>{text}</span><div className="back"></div>
	        </Button>
        </Fragment>
    )
}

